module.exports = __webpack_public_path__ + "img/cnd_Business.ca522088.svg";